<template>
  <div>
    <Sidebar />
    <Content :id="$route.params.id" :name="$route.params.name" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar.vue'; // @ is an alias to /src
import Content from '@/components/SiteDetail.vue'; // @ is an alias to /src

@Component({
  components: {
    Sidebar,
    Content,
  },
})
export default class SiteDetail extends Vue {}
</script>
